import { Diagnosis } from '../hypothesis'

export default [
  {
    /** @type {Diagnosis} */
    diagnosis(answers) {
      if (answers['38'] == '<150') {
        return {
          text: 'não eosinofílica',
          proceed: true,
        }
      }

      if (['150-299', '<=300'].includes(answers['38'])) {
        return {
          text: 'eosinofílica',
          proceed: true,
        }
      }

      return {
        proceed: true,
      }
    },
    version: {
      /** @type {number[]} */
      include: [1],
      /** @type {number[]} */
      exclude: [],
    },
  },
  {
    /** @type {Diagnosis} */
    diagnosis(answers) {
      const parsedAnswer38 = parseInt(answers['38']) || null

      if (!parsedAnswer38) {
        return {
          proceed: true,
        }
      }

      if (parsedAnswer38 < 150) {
        return {
          text: 'não eosinofílica',
          proceed: true,
        }
      }

      return {
        text: 'eosinofílica',
        proceed: true,
      }
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [1],
    },
  },
]
